import { render, staticRenderFns } from "./FeedbackFileUpload.vue?vue&type=template&id=60ea2c6a&scoped=true"
import script from "./FeedbackFileUpload.vue?vue&type=script&lang=js"
export * from "./FeedbackFileUpload.vue?vue&type=script&lang=js"
import style0 from "./FeedbackFileUpload.vue?vue&type=style&index=0&id=60ea2c6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea2c6a",
  null
  
)

export default component.exports